// const state = { plan: 'sub', navSel: 'people' };

const state = { 
  plan: 'sub',
  navSel: window.TRP_PRODUCT_GRID?.gridKey || 'people'
};
function money(val) {
  if (val === null || val === undefined || val === '') return null;
  return `$${Number(val).toFixed(2)}`;
}

function buildPacks() {
  const sub = state.plan === 'sub';
  const P = window.TRP_PRODUCTS || {};

  const p2  = P['that-red-patch-2-pack'] || {};
  const p5  = P['that-red-patch-5-pack'] || {};
  const p10 = P['that-red-patch-10-pack'] || {};
  const p20 = P['that-red-patch-20-pack'] || {};
  const packs = [
    {
      name: '2-Patch Pouch',
      handle: 'that-red-patch-2-pack',
      countLabel: '2 Wearable Patches',
      badge: null,
      highlighted: false,
      priceLabel: money(p2.price) || '$19.99',
      priceNote: window.TRP_COUNTRY_CODE === 'US'
        ? '+ $7.95 U.S. Shipping'
        : 'International Shipping Calculated at Checkout',
      wasLabel: null,
      saveLabel: null,
      planNote: null,
      benefit: null,
      benefits: ['2 wearable patches', 'All-natural formula', 'Up to 12 hours of support'],
      ctaLabel: `Add To Cart · ${money(p2.price) || '$19.99'}`,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0638/9402/8384/files/2-PATCHES-POUCH.png?v=1781808473',
    },
    {
      name: '5-Patch Pouch',
      countLabel: '5 Patches Per Pouch',
      handle: 'that-red-patch-5-pack',
      badge: null,
      highlighted: false,

      priceLabel: sub ? money(p5.subPrice || p5.price) : money(p5.price),

      priceNote: sub ? 'Today' : null,
      wasLabel: null,
      saveLabel: sub ? 'Intro Offer' : null,

      planNote: sub
        ? `Then ${money(p5.price)} every 30 days. Free shipping on recurring subscription orders.`
        : null,

      benefit: sub
        ? 'Five patches per pouch, delivered fresh every 30 days.'
        : null,

      ctaLabel: sub ? 'Start My Plan' : 'Add To Cart',
    },
    // {
    //   name: '5-Patch Pouch',
    //   countLabel: '5 Patches Per Pouch',
    //   handle: 'that-red-patch-5-pack',
    //   badge: null,
    //   highlighted: false,
    //   // priceLabel: sub ? money(p5.price) : money(p5.price),
    //   priceLabel: sub ? money(p5.subPrice) : money(p5.price),
    //   priceNote: sub ? 'Today' : null,
    //   wasLabel: null,
    //   saveLabel: sub ? 'Intro Offer' : null,
    //   planNote: sub ? `Then ${money(p5.price)} every 30 days. Free shipping on recurring subscription orders.` : null,
    //   benefit: sub ? 'Five patches per pouch, delivered fresh every 30 days.' : null,
    //   ctaLabel: sub ? 'Start My Plan' : 'Add To Cart',
    // },
    {
      name: '10-Patch Pouch',
      countLabel: '10 Patches Per Pouch',
      handle: 'that-red-patch-10-pack',
      badge: 'Most Popular',
      highlighted: true,
      priceLabel: sub ? money(p10.subPrice) : money(p10.price),
      priceNote: sub ? 'Every 30 Days' : 'One-Time Purchase',
      wasLabel: money(p10.compareAtPrice),
      saveLabel:  'Save 10%' ,
      planNote: sub ? 'Delivered every 30 days. Free shipping on recurring subscription orders. Skip, pause, or cancel anytime.' : null,
      benefit: 'Our best-selling pouch.',
      ctaLabel: sub ? 'Start My Plan' : 'Add To Cart',
    },
    {
      name: '20-Patch Pouch',
      countLabel: '20 Patches Per Pouch',
      handle: 'that-red-patch-20-pack',
      badge: null,
      highlighted: false,
      priceLabel: sub ? money(p20.subPrice) : money(p20.price),
      priceNote: sub ? 'Every 30 Days' : 'One-Time Purchase',
      wasLabel: money(p20.compareAtPrice),
      saveLabel:'Save 10%' ,
      planNote: sub ? 'Delivered every 30 days. Free shipping on recurring subscription orders. Skip, pause, or cancel anytime.' : null,
      benefit: sub ? 'Twenty patches per pouch. Best value per patch.' : 'Stock up for the long haul — twenty patches, best value.',
      ctaLabel: sub ? 'Start My Plan' : 'Add To Cart',
    },
  ];

  return sub ? packs.filter((pack) => pack.handle !== 'that-red-patch-2-pack') : packs;
}


function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[char]));
}


function productCard(pack, gridKey) {
  const pouchSrc = pack.imageUrl || window.TRP_ASSETS?.pouch || 'assets/new-product-img.png';
  const packNumber = pack.handle.match(/(?:^|-)(2|5|10|20)(?:-|$)/)?.[1] || pack.handle;
  const isDesignOnly = pack.designOnly === true;
  const url = isDesignOnly ? '#' : gridKey === 'pets'
    ? `/pages/that-red-patch-for-pets?pack=${encodeURIComponent(packNumber)}`
    : `/products/${pack.handle}`;

  const variantId = window.TRP_PRODUCTS?.[pack.handle]?.variantId || '';
  // One-time purchase, non-pets grid => AJAX add to cart. Pets/subscribe still navigate.
  // const isCartAction = gridKey !== 'pets' && state.plan === 'one';
  const isCartAction = state.plan === 'one' && !isDesignOnly;

  return `
    <div class="trp-prodcard ${pack.highlighted ? 'is-highlighted' : ''} ${isDesignOnly ? 'is-design-only' : ''} trp-u-059">
      ${pack.badge ? `<div class="trp-u-060">${escapeHtml(pack.badge)}</div>` : ''}
      <div class="trp-u-061">
        <img src="${escapeHtml(pouchSrc)}" alt="That Red Patch pouch" class="trp-u-062">
      </div>
      <div class="trp-u-063">
        <h3 class="trp-u-064">${escapeHtml(pack.name)}</h3>
        <div class="trp-u-065">${escapeHtml(pack.countLabel)}</div>
        <div class="trp-u-066"></div>
        ${pack.priceLabel ? `<div class="trp-u-067"><span class="trp-u-068">${escapeHtml(pack.priceLabel)}</span>${pack.wasLabel ? `<span class="trp-u-069">${escapeHtml(pack.wasLabel)}</span>` : ''}</div>` : ''}
        <div class="trp-u-070">
          ${pack.priceNote ? `<span class="trp-u-071">${escapeHtml(pack.priceNote)}</span>` : ''}
          ${pack.saveLabel ? `<span class="trp-u-072">${escapeHtml(pack.saveLabel)}</span>` : ''}
        </div>
        ${pack.planNote ? `<p class="trp-u-073">${escapeHtml(pack.planNote)}</p>` : ''}
        ${pack.benefit ? `<p class="trp-u-074">${escapeHtml(pack.benefit)}</p>` : ''}
        ${pack.benefits ? `<ul class="trp-u-074 trp-u-074--benefits">${pack.benefits.map((benefit) => `<li>${escapeHtml(benefit)}</li>`).join('')}</ul>` : ''}
        <div class="trp-u-075"></div>
        <a href="${url}"
        data-pack-handle="${pack.handle}"
        data-grid-key="${gridKey}"
        ${isDesignOnly ? 'data-design-only="true" aria-disabled="true"' : ''}
        ${isCartAction ? `data-cta-action="cart" data-variant-id="${escapeHtml(variantId)}"` : ''}
        class="trp-cta-btn trp-u-076">
            ${escapeHtml(pack.ctaLabel)} <svg class="trp-cta-btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="13 6 19 12 13 18"></polyline></svg>
        </a>
      </div>
    </div>`;
}


function renderProducts() {
  document.querySelectorAll('[data-product-grid]').forEach((grid) => {

    const gridKey = grid.dataset.productGrid;

    const cards = buildPacks()
      .map((pack) => productCard(pack, gridKey))
      .join('');

    grid.innerHTML = cards;
  });
}

function updateControls() {
  document.querySelectorAll('[data-plan-button]').forEach((button) => {
    const isActive = button.dataset.planButton === state.plan;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-selected', String(isActive));
  });
  document.querySelectorAll('[data-nav-button]').forEach((button) => {
    const isActive = button.dataset.navButton === state.navSel;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-selected', String(isActive));
  });
}

function initReveal() {
  const reveal = (el) => {
    el.classList.add('in');
    el.classList.add('card-box-grid');
  };
  const els = Array.from(document.querySelectorAll('[data-reveal]'));
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach((el) => io.observe(el));
  } else {
    els.forEach(reveal);
  }
  setTimeout(() => els.forEach(reveal), 1800);
}





document.addEventListener('DOMContentLoaded', () => {
  renderProducts();
  updateControls();
  initReveal();

  document.querySelectorAll('[data-plan-button]').forEach((button) => {
    button.addEventListener('click', () => {
      state.plan = button.dataset.planButton;
      renderProducts();
      updateControls();
    });
  });
});


function openCartDrawer(cart) {
  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: cart,
      sourceId: 'trp-all-products',
      data: { itemCount: Number(cart.item_count || 0) }
    }
  }));

  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return;

  const doOpen = () => {
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const trigger = drawer.querySelector('[on\\:click="/open"], button');
    if (trigger) trigger.click();
  };

  if (window.customElements?.whenDefined) {
    window.customElements.whenDefined('cart-drawer-component').then(() => requestAnimationFrame(doOpen));
  } else {
    requestAnimationFrame(doOpen);
  }
}

async function addToCartAjax(variantId) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });

  if (!res.ok) {
    const errData = await res.json().catch(() => ({}));
    throw new Error(errData.description || 'Add to cart failed');
  }

  return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.trp-cta-btn');
  if (!btn) return;

  if (btn.dataset.designOnly === 'true') {
    e.preventDefault();
    return;
  }

  // Pets grid + Subscribe mode => purana navigate + sessionStorage behavior
  if (btn.dataset.gridKey === 'pets' && btn.dataset.ctaAction !== 'cart') {
    const pack = btn.dataset.packHandle.match(/(?:^|-)(2|5|10|20)(?:-|$)/)?.[1] || btn.dataset.packHandle;
    sessionStorage.setItem('trp_selected_pack', pack);
    return;
  }

  // People ya Pets, dono ke liye One-Time mode => AJAX add to cart
  if (btn.dataset.ctaAction === 'cart') {
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');

    addToCartAjax(variantId)
      .then((cart) => {
        openCartDrawer(cart);
      })
      .catch((err) => {
        console.error('TRP add to cart error:', err.message);
      })
      .finally(() => {
        btn.classList.remove('is-loading');
      });
  }
});
